/**
 * ShiftMinimal — scroll-reveal behavior.
 *
 * Collection rendering deliberately remains in the collection section. This
 * asset must never replace the product grid with a second, client-rendered
 * collection experience.
 */
export function initScrollReveal(scope = document) {
  const elements = scope.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach((element) => element.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
  );

  elements.forEach((element) => observer.observe(element));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initScrollReveal(), { once: true });
} else {
  initScrollReveal();
}
